import clsx from 'clsx';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import { ElementProps } from '@/components/sections/builder/types';
import { CollageElementDataType } from '@/components/sections/builder/elements/body/collage/type';
import { cn } from '@/lib/utils';

export default function ElementContent({ element, preview }: ElementProps) {
  const data = element.data as CollageElementDataType;
  const childs = element.childs || [];

  return (
    <>
      <section className='collage_background'>
        <div className='theme_layout_page_width mx-auto duration-100'>
          <div
            className={clsx(
              'collage_wrapper relative px-6 lg:px-6',
              data.contentAlign === 'left' && '[&>*]:text-left',
              data.contentAlign === 'center' && '[&>*]:text-center',
              data.contentAlign === 'right' && '[&>*]:text-right'
            )}
          >
            <h2
              className={clsx(
                'heading_collage theme_font_heading mb-6  tracking-tight text-gray-900',

                data.headingSize === 'extraExtraLarge' &&
                  'text-6xl @sm:text-6xl md:text-6xl lg:text-6xl',
                data.headingSize === 'extraLarge' &&
                  'text-5xl @sm:text-5xl md:text-5xl lg:text-5xl',
                data.headingSize === 'large' && 'text-3xl @sm:text-3xl md:text-5xl lg:text-5xl',
                data.headingSize === 'medium' && 'text-2xl @sm:text-2xl md:text-3xl lg:text-4xl',
                data.headingSize === 'small' && 'text-xl @sm:text-xl md:text-2xl lg:text-3xl'
              )}
              data-animation='true'
              dangerouslySetInnerHTML={{ __html: data.headingLabel }}
            ></h2>

            <div>
              <div className='grid grid-cols-3 gap-2'>
                <div
                  className={cn(
                    'col-span-3',
                    data.desktopLayout === 'largeLeftBlock' ? 'lg:col-span-2' : 'lg:col-span-1'
                  )}
                >
                  <div
                    className={cn(
                      'relative h-full overflow-hidden',
                      data.desktopLayout === 'largeRightBlock'
                        ? `${
                            data.mobileLayout !== 'column' &&
                            childs.length >= 3 &&
                            'grid grid-cols-2 gap-2 lg:block'
                          } lg:w-full`
                        : 'w-full'
                    )}
                  >
                    <WrapperChild
                      child={{
                        ...childs[0],
                        parentData: {
                          ...data,
                          imageClass:
                            data.desktopLayout === 'largeRightBlock' ? 'h-auto lg:h-max ' : '',
                        },
                      }}
                      isUseWrapperClass
                      className={
                        data.desktopLayout === 'largeLeftBlock'
                          ? 'h-full pb-2'
                          : 'pb-2 lg:col-span-2'
                      }
                      parentType={element.type}
                      preview={preview}
                    />
                    {childs[1] &&
                      data.desktopLayout === 'largeRightBlock' &&
                      childs.length >= 3 && (
                        <WrapperChild
                          child={{
                            ...childs[1],
                            parentData: { ...data, imageClass: 'h-auto lg:h-max' },
                          }}
                          parentType={element.type}
                          preview={preview}
                          isUseWrapperClass
                          className='lg:col-span-2'
                        />
                      )}
                  </div>
                </div>
                {childs[1] && (
                  <div
                    className={cn(
                      'col-span-3 ',
                      data.desktopLayout === 'largeLeftBlock' ? 'lg:col-span-1' : 'lg:col-span-2'
                    )}
                  >
                    <div
                      className={cn(
                        data.desktopLayout === 'largeLeftBlock'
                          ? `${
                              data.mobileLayout !== 'column' &&
                              childs.length >= 3 &&
                              'grid grid-cols-2 gap-2'
                            } lg:block lg:h-full lg:w-full lg:justify-between`
                          : 'h-full w-full'
                      )}
                    >
                      {(data.desktopLayout === 'largeLeftBlock' ||
                        (data.desktopLayout === 'largeRightBlock' && childs.length < 3)) && (
                        <div className={cn('relative h-full overflow-hidden pb-2 lg:h-max')}>
                          <WrapperChild
                            child={{
                              ...childs[1],
                              parentData: {
                                ...data,
                                imageClass: `h-auto ${
                                  data.desktopLayout !== 'largeRightBlock' ? 'lg:h-full' : 'h-full'
                                }`,
                              },
                            }}
                            isUseWrapperClass
                            className='h-full'
                            parentType={element.type}
                            preview={preview}
                          />
                        </div>
                      )}
                      {childs[2] && (
                        <div
                          className={cn(
                            'relative h-full overflow-hidden',
                            data.desktopLayout === 'largeLeftBlock' && 'lg:h-max'
                          )}
                        >
                          <WrapperChild
                            child={{
                              ...childs[2],
                              parentData: {
                                ...data,
                                imageClass:
                                  data.desktopLayout === 'largeLeftBlock'
                                    ? 'h-auto lg:h-full'
                                    : 'h-full',
                              },
                            }}
                            isUseWrapperClass
                            className='lg:flex-column h-full lg:flex lg:justify-between'
                            parentType={element.type}
                            preview={preview}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .collage_wrapper {
            padding-top: ${data.topPadding}px;
            padding-bottom: ${data.bottomPadding}px;
          }
          .collage_background {
            background-color: ${data.colorSchemeCollageSection?.background || 'white'};
            color: ${data.colorSchemeCollageSection?.text || '#52535B'};
          }
          .heading_collage {
            color: ${data.colorSchemeCollageSection?.text || '#52535B'};
          }
        `}
      </style>
    </>
  );
}
